$(document).ready(function(){
  $("a#inline").fancybox({
    touch:false
  }); 
  $(".ProductCertifiedUsedPopup a#Certified_UsedButton").fancybox({
    touch:false
  }); 
  
  var Pageurl = window.location.href;
  //console.log("Pageurl " + Pageurl);
  if (window.location.href.indexOf("de") > -1) {
    //alert("german");
    $(".GermanImageSec").show();
    $(".FrenchImageSec").hide();
  }else{
    //alert("french");
    $(".FrenchImageSec").show();
    $(".GermanImageSec").hide();
  }

  $('.AccountTab ul.tabs').each(function(){
    var active, content, links = $(this).find('a.AccountTabHeading');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a.AccountTabHeading').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });


var gh=[];
  




  setTimeout(function () {
    //var url = window.location.href;
    //console.log("updated url "+ url);
    $(".gf-block-content.globo-selected-items .selected-item.gf-option-label").each(function(){
      var selectedfilterdivlength = $(".gf-block-content.globo-selected-items .selected-item.gf-option-label").length;
      console.log("div length "+ selectedfilterdivlength);
      if(selectedfilterdivlength == 1){
        console.log("if div count equal to 1");
        var selectedfilter = $(this).children("a").attr("data-selectedval");         
        console.log("ArrayFilterData "+selectedfilter);
        
        gh.push(selectedfilter);
        $(".HiddenSaveSearchData").append(selectedfilter);
        
        var selectedFilterData = $(".HiddenSaveSearchData").text();
        console.log("hidden data "+selectedFilterData);
        
        $(".newsletter .newsletterHiddenValue").val(gh);
      }else{
        console.log("else div count greater than 1");
        var selectedfilter = $(this).children("a").attr("data-selectedval");         
        console.log("ArrayFilterData "+selectedfilter);
        gh.push(selectedfilter);
        $(".HiddenSaveSearchData").append(selectedfilter+",");
        
        var selectedFilterData = $(".HiddenSaveSearchData").text();
        console.log("hidden data "+selectedFilterData);
        
        $(".newsletter .newsletterHiddenValue").val(gh);
      }
    });
  }, 2000);




  $('body').on('click', '.gf-filter-contents .gf-block-content ul li a', function() {
    setTimeout(function () {
      //var url = window.location.href;
      //console.log("updated url "+ url);
      $(".gf-block-content.globo-selected-items .selected-item.gf-option-label").each(function(){
        var selectedfilterdivlength = $(".gf-block-content.globo-selected-items .selected-item.gf-option-label").length;
        console.log("div length "+ selectedfilterdivlength);
        if(selectedfilterdivlength == 1){
          console.log("if div count equal to 1");
          var selectedfilter = $(this).children("a").attr("data-selectedval");   
          console.log("ArrayFilterData "+selectedfilter);
          gh.push(selectedfilter);
          $(".HiddenSaveSearchData").append(selectedfilter);
        
        var selectedFilterData = $(".HiddenSaveSearchData").text();
        console.log("hidden data "+selectedFilterData);
          
          $(".newsletter .newsletterHiddenValue").val(gh);
        }else{
          console.log("else div count greater than 1");
          var selectedfilter = $(this).children("a").attr("data-selectedval");         
          console.log("ArrayFilterData "+selectedfilter);
          
          $(".HiddenSaveSearchData").append(selectedfilter+",");
        
        var selectedFilterData = $(".HiddenSaveSearchData").text();
        console.log("hidden data "+selectedFilterData);
          gh.push(selectedfilter);
          $(".newsletter .newsletterHiddenValue").val(gh);
        }
      });
    }, 2000);
  }); 


  $('body').on('click', '.CollectionSaveSearchSec .SaveSearchBtn', function() {
    $('.newsletter .newsletter__btn').trigger('click');
  });

});